import { useConstant } from "./useConstant.js";
import { validateTidalLicense } from "../../base/index.js";
validateTidalLicense();
export {
  useConstant
};
//# sourceMappingURL=index.js.map
